import { createReducer } from '@reduxjs/toolkit'
import { Actions_TrackerCodes } from './Actions'
import { IStateTrackerCodes } from './TReducer'

const initialState: IStateTrackerCodes = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerTrackerCodes = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_TrackerCodes.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_TrackerCodes.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_TrackerCodes.store.saveTrackerCodes, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_TrackerCodes.store.filterTrackerCodes, (state, action) => {
      const payload = action.payload
      return { ...state, data: state.data ? state.data?.filter((item) => item.id !== payload) : null }
    })
    .addCase(Actions_TrackerCodes.store.unshiftToTrackerCodes, (state, action) => {
      const payload = action.payload

      if (!state.data) {
        return { ...state, data: [payload] }
      }

      const newData = [...state.data, payload]

      return { ...state, data: newData }
    })
    .addCase(Actions_TrackerCodes.store.reset, () => {
      return initialState
    })
})

export default ReducerTrackerCodes
